<template>
	<div>
		<v-tabs-items :value="tab">
			<template v-for="{ slot } in tabs">
				<v-tab-item
					:key="slot"
					:value="slot"
					transition="none"
				>
					<slot :name="slot" />
				</v-tab-item>
			</template>
		</v-tabs-items>
	</div>
</template>

<script>
export default {
	props: {
		tab: {
			type: String,
			required: true
		},
		tabs: {
			type: Array,
			required: true
		}
	}
}
</script>
